import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { AccountManagersQuery } from './__generated__/AccountManagersQuery';
import { kmsClient } from 'api';
import { ACCOUNT_MANAGERS_QUERY } from './accountManagers.query';

export const useAccountManagersQuery = () => {
  return useQuery<AccountManagersQuery>(ACCOUNT_MANAGERS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};

export const useAccountManagersLazyQuery = () => {
  return useLazyQuery<AccountManagersQuery>(ACCOUNT_MANAGERS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
